module.exports = __webpack_public_path__ + "./images/blue_marker.60c1d4.svg";